export const WEEK_DAYS = [
  { index: 0, short: 'شنبه', label: 'شنبه' },
  { index: 1, short: '۱ش', label: 'یکشنبه' },
  { index: 2, short: '۲ش', label: 'دوشنبه' },
  { index: 3, short: '۳ش', label: 'سه‌شنبه' },
  { index: 4, short: '۴ش', label: 'چهارشنبه' },
  { index: 5, short: '۵ش', label: 'پنج‌شنبه' },
  { index: 6, short: 'جمعه', label: 'جمعه' },
];

export function getTodayDayOfWeek() {
  return (new Date().getDay() + 1) % 7;
}

export function getDayLabel(dayOfWeek) {
  return WEEK_DAYS.find((day) => day.index === dayOfWeek)?.label || 'نامشخص';
}

export function parseTimeToMinutes(time) {
  if (!time) {
    return 0;
  }

  const [hours, minutes] = time.split(':').map(Number);

  return (hours || 0) * 60 + (minutes || 0);
}

export function formatTime(time) {
  if (!time) {
    return '--:--';
  }

  return time;
}

export function formatDuration(startTime, endTime) {
  const durationMinutes = parseTimeToMinutes(endTime) - parseTimeToMinutes(startTime);

  if (durationMinutes <= 0) {
    return '';
  }

  const hours = Math.floor(durationMinutes / 60);
  const minutes = durationMinutes % 60;

  if (hours && minutes) {
    return `${hours} ساعت و ${minutes} دقیقه`;
  }

  if (hours) {
    return `${hours} ساعت`;
  }

  return `${minutes} دقیقه`;
}

export function getPeriodSortOrder(item) {
  const order = item?.period?.sortOrder ?? item?.sortOrder;

  return Number.isFinite(order) ? order : Number.MAX_SAFE_INTEGER;
}

export function sortPeriods(periods = []) {
  return [...periods].sort((first, second) => (first.sortOrder ?? 0) - (second.sortOrder ?? 0));
}

export function formatPeriodRange(period) {
  const start = period?.startTime ? formatTime(period.startTime.slice(0, 5)) : '';
  const end = period?.endTime ? formatTime(period.endTime.slice(0, 5)) : '';

  if (start && end) {
    return `${start}–${end}`;
  }

  return start || end || '';
}

export function resolvePeriods(periods = [], scheduleItems = []) {
  if (periods.length > 0) {
    return sortPeriods(periods);
  }

  const byId = new Map();

  scheduleItems.forEach((item) => {
    if (item.period?.id && !byId.has(item.period.id)) {
      byId.set(item.period.id, item.period);
    }
  });

  return sortPeriods([...byId.values()]);
}

export function groupScheduleByDay(scheduleItems = []) {
  return WEEK_DAYS.map((day) => ({
    ...day,
    items: scheduleItems
      .filter((item) => item.dayOfWeek === day.index)
      .sort((first, second) => getPeriodSortOrder(first) - getPeriodSortOrder(second)),
  }));
}

export function countScheduleItems(scheduleItems = []) {
  return scheduleItems.length;
}

export function countTodayItems(scheduleItems = [], todayIndex = getTodayDayOfWeek()) {
  return scheduleItems.filter((item) => item.dayOfWeek === todayIndex).length;
}
